/**
 * Tabbed Component
 * @file ES6 component to handle vertical tabs component.
 */

class Tabbed {
  constructor(el) {
    this.element = el;
    this.tabList = this.element.querySelectorAll('.tabbed-menu ul li a');
    this.panels = this.element.querySelectorAll('.tabbed-item');
    this.menuClass = 'tabbed-menu';
    this.toggleClass = 'tabbed-toggle';
    this.activeClass = 'active';

    this.handleClick = this.handleClick.bind(this);
    this.handleToggle = this.handleToggle.bind(this);
    this.handleKeypress = this.handleKeypress.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    // Get the id from the href
    const id = e.currentTarget.getAttribute('href');
    // set the location
    window.location.hash = id;
    // Show the panel
    this.hidePanels();
    this.showPanel(id.replace('#', ''));
    // Set the active tab
    this.setAllInactiveTabs();
    this.setActiveTab(id);
    // Close mobile menu
    this.handleToggle();
  }

  setTabListeners() {
    this.tabList.forEach((item) => {
      item.addEventListener('click', this.handleClick, false);
    });
  }

  hidePanels() {
    this.panels.forEach((panel) => {
      panel.classList.remove(this.activeClass);
    });
  }

  showPanel(id) {
    const panel = document.getElementById(id);
    panel.classList.add(this.activeClass);
  }

  setActiveTab(id) {
    const tab = this.element.querySelector(`[href="${id}"]`);
    tab.classList.add(this.activeClass);
    this.toggle.innerText = tab.innerText;
  }

  setAllInactiveTabs() {
    this.tabList.forEach((tab) => {
      tab.classList.remove(this.activeClass);
    });
  }

  createToggle() {
    this.toggle = document.createElement('button');
    this.toggle.setAttribute('class', this.toggleClass);
    this.toggle.innerText = this.tabList[0].innerText;
    this.element.appendChild(this.toggle);
    this.addToggleEvents();
    return this.toggle;
  }

  handleToggle() {
    const menu = this.element.querySelector(`.${this.menuClass}`);
    if (menu.classList.contains(this.activeClass)) {
      menu.classList.remove(this.activeClass);
    }
    else {
      menu.classList.add(this.activeClass);
    }
  }

  handleKeypress(e) {
    switch (e.code) {
      case 'Tab':
        this.tabList[0].focus();
        break;
      default:
        break;
    }
  }

  addToggleEvents() {
    this.toggle.addEventListener('click', this.handleToggle);
    this.toggle.addEventListener('keydown', this.handleKeypress);
  }

  init() {
    this.setTabListeners();
    this.createToggle();
  }
}

/**
 * Initialise for default class.
 */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.tabbed').forEach((obj) => {
    const tabbedComponent = new Tabbed(obj);
    tabbedComponent.init();
  });
});

export default Tabbed;
